import {
  Card,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Divider,
  Box,
} from "@mui/material"
import PersonIcon from "@mui/icons-material/Person"
import EmailIcon from "@mui/icons-material/Email"
import PhoneIcon from "@mui/icons-material/Phone"
import HomeIcon from "@mui/icons-material/Home"

const CustomerDetails = ({ order }) => {
  const customer = order?.customer

  return (
    <Card
      sx={{
        boxShadow: 1,
        borderRadius: 2,
        p: 3,
        width: "100%",
      }}
    >
      <Typography
        variant="h6"
        fontWeight={600}
        gutterBottom
        color="text.primary"
      >
        Customer Details
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell
              sx={{
                border: "none",
                padding: "8px 0",
                color: "text.secondary",
                width: "35%",
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <PersonIcon fontSize="small" />
                Name:
              </Box>
            </TableCell>
            <TableCell sx={{ border: "none", padding: "8px 0" }}>
              {customer?.name || "—"}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell
              sx={{
                border: "none",
                padding: "8px 0",
                color: "text.secondary",
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <EmailIcon fontSize="small" />
                Email:
              </Box>
            </TableCell>
            <TableCell sx={{ border: "none", padding: "8px 0" }}>
              {customer?.email || "—"}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell
              sx={{
                border: "none",
                padding: "8px 0",
                color: "text.secondary",
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <PhoneIcon fontSize="small" />
                Phone:
              </Box>
            </TableCell>
            <TableCell sx={{ border: "none", padding: "8px 0" }}>
              {customer?.phone || "—"}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell
              sx={{
                border: "none",
                padding: "8px 0",
                color: "text.secondary",
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <HomeIcon fontSize="small" />
                Address:
              </Box>
            </TableCell>
            <TableCell sx={{ border: "none", padding: "8px 0" }}>
              {customer?.address || "—"}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  )
}

export default CustomerDetails
